export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6644.e1da7fd6.jpg";